import { Injectable } from '@angular/core';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";

@Injectable()
export class AlertsService {
  private Http: HttpInterceptor2;
  private API_URL = GlobalVariable.API_URL;

  constructor (public httpInterceptor: HttpInterceptor2) {
    this.Http = httpInterceptor;
  }

  getAlerts(searchQuery,limit?,page?){
    let l=10;
    let p= 1;

    if (page) p=page;
    if (limit) l=limit;

    return this.Http.post(this.API_URL+'/alert/query?limit='+l+'&page='+p,searchQuery)
  }

}



// WEBPACK FOOTER //
// ./src/services/alerts.service.ts